import { login, } from './jkUser';
import { Cmsma } from "./Cmsma-angular";
import { AppPage, jkRestReturnClass } from "./jkClass";
import { jkLib } from "./jkCommon";
import { idNameItem, JkEnvironment, JkEnvironmentDefault, jkRestReturn } from "./jkInterface";
import { OrmService } from './jkOrm';
import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';

//export const login: LoginService = new LoginService();
//export let orm: OrmService;
//export let pages: AppPage[] = [];

// 應該不適合改為 Injectable

/*
@Injectable({
  providedIn: 'root',
})*/
export class JkGlbClass {
  language = '';
  cmsma: Cmsma = new Cmsma();
  cmskb: idNameItem[] = [];
  env: JkEnvironment = JkEnvironmentDefault;
  pages: AppPage[] = [];
  dateKind: number;
  dateSymbol: string;
  dollar = 'NTD';
  companyList: idNameItem[] = [];
  //login : LoginService = inject(LoginService);
  orm!: OrmService; // 只能用 init = new OrmService(); // inject(OrmService); // Will be initialized later
  config: any;
  //orm: OrmService = inject(OrmService); // Will be initialized later
  constructor() {// injector: Injector public login : LoginService
    this.dateKind = 1;
    this.dateSymbol = '/';
    this.language = navigator.language;
  };

  async init(defaultLogin: boolean, env: JkEnvironment, companyList: idNameItem[], pages: AppPage[], orm: OrmService) {// http: HttpClient
    //this.orm.init(http);
    this.orm = orm;
    //orm = this.orm;
    //this.login= inject.get(LoginService);
    //this.login.init(env.appId,36);
    //this.login.userCreate(true);
    login.init(defaultLogin, env.appId, env.envExpireHour);
    this.companyList.push(...companyList);
    try {
      this.pages.push(...pages);
      //this.env = env;
      jkLib.cloneField(env, this.env);
      //jkLib.cloneField(cmsma, this.cmsma);
    } catch (error: any) {

    }
    await this.initAll();
    /*getIp(self:JkGlbClass){// myip address
      var xhr = new XMLHttpRequest();
      xhr.open("GET", "https://api.ipify.org?format=json", true);
      xhr.onreadystatechange = function() {
        if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
          var response = JSON.parse(xhr.responseText);
          self.ip = response.ip;
          // console.log("Your IP is:", response.ip);
        }
      };
      xhr.send();
    }*/
  };
  async initAll() {
    if (!this.orm) {
      const errorMessage = 'jkGlb.initAll ORM service not initialized. Call initOrm() first.';
      console.warn(errorMessage);
      alert(errorMessage);
      return;
    }
    if ((!login.hostName) || (login.hostName === 'http://localhost:4200')) {
      const path = window.location.pathname.replace(/\/+$/, '');
      if (!path.endsWith('/helpviewer')) {
        const msg = '尚未登入';
        alert(msg);
      }
      return;
    }
    let ret: jkRestReturn = new jkRestReturnClass();
    this.config = await this.orm.getFrontConfig(this.env.configFileName, ret);

    this.orm.doOpenWin_get('S', 'CMSKB', 'S01', []).subscribe({
      next: (data) => {
        //console.log('✅ [DEBUG] doOpenWin_get 請求成功完成，沒有 keepalive 錯誤');

        if (data.result) {
          this.cmskb = data.obj;
          let item = this.cmskb.find(item => {
            return item.id === '_UPLOAD_HOST';
          });
          if (item) {
            this.env.baseAttachUrl = item.name;
            //console.log('jkGlb.env.baseAttachUrl=', this.env.baseAttachUrl);
          } else {
            console.error('CMSKB _UPLOAD_HOST 不存在.');
          }
          item = this.cmskb.find(item => {
            return item.id === '_REPORT_URL';
          });
          if (item) {
            this.env.reportUrl = item.name;
            //console.log('jkGlb.env.reportUrl=', this.env.reportUrl);
          } else {
            console.error('CMSKB _REPORT_URL 不存在.');
          }

        }
      },
      error: (error: any) => {
        alert("doOpenWin_get('S','CMSKB','S01',[]) 錯誤,可能server api 未啟動: " + error.message);
      }
    });
  }

}

// 有 new 就不能 inject
export let jkGlb: JkGlbClass = new JkGlbClass(); // (1,'/')
